import { CalendarDate } from "@internationalized/date";

/**
 * A small wrapper around a request-preference for an inspection
 */
export default class InspectionRequestPreference {
  private _date: CalendarDate;
  private meridiem: "AM" | "PM" | null;

  constructor(date: CalendarDate, meridiem: "AM" | "PM" | null) {
    this._date = date;
    this.meridiem = meridiem;
  }

  get date(): CalendarDate {
    return this._date;
  }

  hasAmPreference(): boolean {
    return this.meridiem === "AM" || this.meridiem === null;
  }

  hasPmPreference(): boolean {
    return this.meridiem === "PM" || this.meridiem === null;
  }
}
